import * as React from 'react';

var useKey = 'use';
// @TODO: Remove this file and import directly from React when available.
var use = React[useKey];

export { use };
